import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import usePageContent from '../../hooks/usePageContent';

const FeatureListHome = () => {
    const { lang } = useParams();
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'Feature', language: "en-US" });
        }

        if (status === 'done') {
            setDataPromo(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    return (
        <section className="shipping mt-40 mb-24" id="shipping">
            <div className="container container-md">
                <div className="row gy-4">
                    {
                        dataPromo.length > 0 && dataPromo.map((item, index) => (
                            <div className="col-xxl-3 col-sm-6" key={index}>
                                <div className="shipping-item flex-align gap-16 rounded-16 bg-main-one-50 hover-bg-main-one-100 transition-2">
                                    <img
                                        src={item.image}
                                        alt=""
                                        className="w-56 h-56 flex-center flex-shrink-0"
                                    />
                                    <div className="">
                                        <h6 className="mb-0">{item.title}</h6>
                                        {/* <span className="text-sm text-heading">
                                            Free shipping all over the US
                                        </span> */}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {/* <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-16 rounded-16 bg-main-one-50 hover-bg-main-one-100 transition-2">
                            <img
                                src='assets/images/features/shipping.png'
                                alt=""
                                className="w-56 h-56 flex-center flex-shrink-0"
                            />
                            <div className="">
                                <h6 className="mb-0">Free Shipping</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-16 rounded-16 bg-main-one-50 hover-bg-main-one-100 transition-2">
                            <img
                                src='assets/images/features/track-shipment.png'
                                alt=""
                                className="w-56 h-56 flex-center flex-shrink-0"
                            />
                            <div className="">
                                <h6 className="mb-0"> Track Shipment</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-16 rounded-16 bg-main-one-50 hover-bg-main-one-100 transition-2">
                            <img
                                src='assets/images/features/secure.png'
                                alt=""
                                className="w-56 h-56 flex-center flex-shrink-0"
                            />
                            <div className="">
                                <h6 className="mb-0"> Secure Payments</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="shipping-item flex-align gap-16 rounded-16 bg-main-one-50 hover-bg-main-one-100 transition-2">
                            <img
                                src='assets/images/features/customer-services.png'
                                alt=""
                                className="w-56 h-56 flex-center flex-shrink-0"
                            />
                            <div className="">
                                <h6 className="mb-0"> 24/7 Support</h6>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>

    )
}

export default FeatureListHome